import { render, staticRenderFns } from "./BaseServerError.vue?vue&type=template&id=77f1ebe2&scoped=true&"
import script from "./BaseServerError.vue?vue&type=script&lang=js&"
export * from "./BaseServerError.vue?vue&type=script&lang=js&"
import style0 from "./BaseServerError.vue?vue&type=style&index=0&id=77f1ebe2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f1ebe2",
  null
  
)

export default component.exports